import { Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'

import { cn } from './lib/ui'

/**
 * What an admin sees where the "Draft with AI" button would be, when this
 * workspace has not connected a Claude account.
 *
 * Deliberately small and link-shaped rather than a banner: the feature is
 * optional, the board is not the place to sell it, and the only useful thing
 * to say is where to switch it on. A member sees nothing at all — the board
 * renders this only when `canManage` is true — because telling someone about a
 * setting they cannot reach is just noise.
 */
export function AiConnectPrompt({ to, className }: { to: string; className?: string }) {
  return (
    <Link
      to={to}
      className={cn(
        'inline-flex h-8 items-center gap-1.5 rounded-lg border border-dashed border-ink-300 px-2.5',
        'text-sm font-medium text-ink-600 transition',
        'hover:border-brand-400 hover:bg-brand-50 hover:text-brand-800',
        'dark:border-ink-700 dark:text-ink-400 dark:hover:border-brand-800 dark:hover:bg-brand-950 dark:hover:text-brand-200',
        className,
      )}
      title="Connect Claude or ChatGPT to draft issues with AI"
    >
      <Sparkles className="size-4 shrink-0" aria-hidden="true" />
      Connect AI to draft
    </Link>
  )
}
